import { InitPage } from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientCustomD365: string;

export interface CustomD365ProgressChannelData {
  message: string;
  progress: number;
  inProgress: boolean;
  success: boolean;
  tag: string;
}

class CustomD365ProgressUpdate {
  customD365ProgressUpdateChannel: any;

  constructor() {
    var x = typeof tenantCode === "undefined" ? "not_available" : tenantCode;
    var isCustomD365 =
      typeof isClientCustomD365 === "undefined" ? false : isClientCustomD365;

    if (isCustomD365 == "true") {
      this.customD365ProgressUpdateChannel = App.cable.subscriptions.create(
        {
          channel: "CustomD365::SyncProgressChannel",
          tenant_code: x,
          roomId: `custom_d365_sync_${x}`,
        },
        {
          connected() {
            console.log("Connected to Custom D365 Progress Update Channel");
          },
          disconnected() {
            console.log("Disconnected to Custom D365 Progress Update Channel");
          },
          received: (data: any) => this.updateProgress(data),
        },
      );
    }
  }

  updateProgress(data: CustomD365ProgressChannelData) {
    console.log(data);

    if (!data.success) {
      this.refresh();
    }

    $("#modal-progress-message").text(data.message);
    $("#custom-d365-progress-message").text(data.message);
    $("#custom-d365-progress-percent").text(`${data.progress}%`);
    $(".progress-bar").css("width", `${data.progress}%`);
    $(".currentStatusDesc_Category").text(`${data.message}`);

    if (
      data.message ==
      'Before syncing, you must download the quantity. Please complete the "Download Quantity” first.'
    ) {
      $(".sync-actions > .previewSyncBtn").hide();
      $(".sync-actions > .custom-d365-sync-btn").hide();
      $(".currentStatus .progress-spin").hide();
      $(".currentStatus .fail-img").hide();
      $(".currentStatusDesc_Category").css("color", "red");
      return;
    }

    if (data.message == "Matching 100%, no discrepancies detected") {
      $(".sync-actions > .previewSyncBtn").hide();
      $(".sync-actions > .custom-d365-sync-btn").hide();
      $(".currentStatus .progress-spin").hide();
      $(".currentStatus .success-img").removeClass("hide").show();
      $(".currentStatus .fail-img").hide();
      return;
    }

    if (data.message == "Preview successfully generated") {
      $(".sync-actions > .previewSyncBtn").removeAttr("disabled");
      $(".sync-actions > .custom-d365-sync-btn").removeAttr("disabled");
      $(".currentStatus .progress-spin").hide();
      $(".currentStatus .fail-img").hide();
      $(".currentStatus .success-img").removeClass("hide").show();
      return;
    }

    if (data.message == "Synchronization completed") {
      $(".currentStatus .progress-spin").hide();
      $(".currentStatus .success-img").removeClass("hide").show();
      $(".currentStatus .fail-img").hide();

      let _this = this;
      setTimeout(function () {
        _this.refresh();
      }, 2000);
      return;
    }

    if (
      data.message == "Download Inventory Completed" ||
      data.message == "Download inventory has been cancelled" ||
      data.message == "Import catalog Completed" ||
      data.message == "Import catalog has been cancelled"
    ) {
      this.refresh();
    }

    if (data.tag == "download_catalog") {
      $("#custom-d365-import-catalog-progress-box").show();
    }
  }

  refresh(): void {
    window.location.reload();
  }
}

export function LoadPage() {
  InitPage("items", () => {
    const t = new CustomD365ProgressUpdate();
  });
  InitPage("compare_v2", () => {
    const t = new CustomD365ProgressUpdate();
  });
}
